// extracted by mini-css-extract-plugin
export default {"totalRecords":"TotalRecords_totalRecords__6szHB"};